/**
 * SAT AURA™ · Frontend API Client (M3)
 *
 * Kein lokales Scoring. Nur Backend-Kalls über den zentralen axios-Client.
 */
import { api } from "./api";

// Session + Consent
export const auraStartSession = () =>
  api.post("/aura/sessions").then((r) => r.data);
export const auraGetCurrentSession = () =>
  api.get("/aura/sessions/current").then((r) => r.data);
export const auraGrantConsent = () =>
  api.post("/aura/consent", { accepted: true }).then((r) => r.data);

// Reality Scan
export const auraUpsertRealityScan = (payload) =>
  api.post("/aura/reality-scan", payload).then((r) => r.data);
export const auraGetRealityScan = () =>
  api.get("/aura/reality-scan").then((r) => r.data);

// Events
export const auraAppendEvent = (payload) =>
  api.post("/aura/events", payload).then((r) => r.data);
export const auraListEvents = () =>
  api.get("/aura/events").then((r) => r.data);

// Finalize + Profile + Map
export const auraFinalize = () =>
  api.post("/aura/finalize").then((r) => r.data);
export const auraGetProfile = () =>
  api.get("/aura/profile/current").then((r) => r.data);
export const auraGetMap = () =>
  api.get("/aura/map/current").then((r) => r.data);

// Resonance
export const auraAttachResonance = (profileId, candidateId, resonance) =>
  api.post("/aura/resonance", {
    profile_id: profileId,
    candidate_id: candidateId,
    resonance,
  }).then((r) => r.data);

// Report Download
export const auraIssueReportToken = () =>
  api.get("/aura/report/current").then((r) => r.data);

export const auraDownloadReport = async () => {
  const { token } = await auraIssueReportToken();
  const resp = await api.get(`/aura/reports/${token}`, { responseType: "blob" });
  const blob = new Blob([resp.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "aura-preview.pdf";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Mentor
export const auraMentorListSessions = () =>
  api.get("/aura/mentor/sessions").then((r) => r.data);
export const auraMentorGetSession = (sessionId) =>
  api.get(`/aura/mentor/sessions/${sessionId}`).then((r) => r.data);
export const auraMentorReview = (sessionId, payload) =>
  api.post(`/aura/mentor/sessions/${sessionId}/review`, payload).then((r) => r.data);
export const auraMentorRelease = (sessionId) =>
  api.post(`/aura/mentor/sessions/${sessionId}/release`).then((r) => r.data);
